export type Role = "member" | "admin";

export interface SessionUser {
  email: string;
  name: string;
  role: Role;
}

const SESSION_KEY = "pota.session";

/** Demo-only credentials — never use in production. */
export const DEMO_USERS: Array<SessionUser & { password: string }> = [
  {
    email: "member@pieceoftheaction.demo",
    password: "member123",
    name: "Alex Member",
    role: "member",
  },
  {
    email: "admin@pieceoftheaction.demo",
    password: "admin123",
    name: "Sam Admin",
    role: "admin",
  },
];

export function getSession(): SessionUser | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SessionUser;
  } catch {
    return null;
  }
}

export function login(email: string, password: string): SessionUser | null {
  const match = DEMO_USERS.find(
    (u) =>
      u.email.toLowerCase() === email.trim().toLowerCase() &&
      u.password === password
  );
  if (!match) return null;
  const session: SessionUser = {
    email: match.email,
    name: match.name,
    role: match.role,
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  return session;
}

export function logout(): void {
  localStorage.removeItem(SESSION_KEY);
}

export function requireRole(role: Role | Role[]): SessionUser | null {
  const session = getSession();
  if (!session) return null;
  if (role === "member") {
    if (session.role === "admin" || session.role === "member") return session;
    return null;
  }
  const allowed = Array.isArray(role) ? role : [role];
  if (!allowed.includes(session.role)) return null;
  return session;
}

export function requireAdmin(): SessionUser | null {
  const session = getSession();
  if (!session || session.role !== "admin") return null;
  return session;
}
